import { render, staticRenderFns } from "./refHouse.vue?vue&type=template&id=1903bd97&"
import script from "./refHouse.vue?vue&type=script&lang=js&"
export * from "./refHouse.vue?vue&type=script&lang=js&"
import style0 from "./refHouse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\TeamCity\\buildAgent\\work\\d66fd695757ba5a4\\src\\SABONyproduktion.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1903bd97', component.options)
    } else {
      api.reload('1903bd97', component.options)
    }
    module.hot.accept("./refHouse.vue?vue&type=template&id=1903bd97&", function () {
      api.rerender('1903bd97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/houseModel/components/refHouse.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./assets/vue/houseModel/components/refHouse.vue
// module id = 472
// module chunks = 0